import React, { useState } from 'react';

type DatepickerProps = {
  onChange?: (selectedOption: string) => void;
  type?: string;
  value?: string;
  className?: string;
  min?: string;
  max?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
};

export const Datepicker: React.FC<DatepickerProps> = ({
  onChange,
  type = 'date',
  value = '',
  className = '',
  min = '',
  max = '',
  required = false,
  disabled = false,
  name = undefined
}) => {
  const [selectedDate, setSelectedDate] = useState(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setSelectedDate(newValue);
    onChange?.(newValue);
  };

  return (
    <input
      className={`bg-sk-grey-200 text-sk-blue-500 active:bg-sk-grey-500 cursor-pointer appearance-none rounded-lg px-4 py-2.5 text-sm disabled:pointer-events-none disabled:cursor-default disabled:opacity-50 ${className}`}
      type={type}
      value={selectedDate}
      min={min}
      max={max}
      onChange={handleChange}
      required={required}
      disabled={disabled}
      name={name}
    />
  );
};
